import ListItem from './ListItem';

export function List({ items }) {
  if (items.length === 0) {
    return <p className="mt-35">You have no appointments for today</p>;
  }
  return (
    <div className="mt-35">
      <h4 className="mb-20">Today</h4>
      {items.map((item) => (
        <ListItem key={item.uuid} item={item} />
      ))}
    </div>
  );
}
